import { NotificationService, NotificationServiceImplBase, ServiceNames } from '@tableau/api-shared-js';

export class InitializationServiceImpl extends NotificationServiceImplBase implements NotificationService {
  public get serviceName(): string {
    return ServiceNames.Initialization;
  }
}
